import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-events',
  templateUrl: './alumni-events.component.html',
  styleUrls: ['./alumni-events.component.scss']
})
export class AlumniEventsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
